import { render, staticRenderFns } from "./form-child-authority.vue?vue&type=template&id=932a9f64"
import script from "./form-child-authority.vue?vue&type=script&lang=js"
export * from "./form-child-authority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports